const supportedLocales = {
  fr: "Français",
  pt: "Português"
};

export const supportedLocalesName = Object.values(supportedLocales);

export default supportedLocales;
